import { CRM } from "@/components/atomic-crm/root/CRM";
import { PWAUpdatePrompt } from "@/components/atomic-crm/pwa/PWAUpdatePrompt";
import { PWAInstallPrompt } from "@/components/atomic-crm/pwa/PWAInstallPrompt";
import { OfflineIndicator } from "@/components/atomic-crm/pwa/OfflineIndicator";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <CRM
 *       logo="./img/logo.png"
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => (
  <>
    <CRM disableTelemetry />
    <OfflineIndicator />
    <PWAUpdatePrompt />
    <PWAInstallPrompt />
  </>
);

export default App;
